<template>
  <div class="app">
    <headNavs :aask="aask" v-if="_isMobile() == null" />
    <headNaves v-else></headNaves>
    <router-view @aas="aas" v-if="a == 0" :key="$route.fullPath" />

    <foot v-if="_isMobile() == null" />
    <foots v-else></foots>
  </div>
</template>
<script>
import '@/assets/css/common.css'
import headNavs from '@/components/headNavsnew.vue'
import headNaves from '@/component/headNavs.vue'

import foot from '@/components/foot.vue'
import foots from '@/component/foot.vue'

export default {
  components: { headNavs, foot, headNaves, foots },
  data() {
    return {
      a: 0,
      aask: 0,
    }
  },
  methods: {
    _isMobile() {
      const flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      // console.log(flag, null, '-0--------------flag')
      return flag
    },
    aas() {
      this.aask = 1
    },
    aaa() {
      // console.log('---------aaaa------')
      this.a = 1
      setTimeout(() => {
        this.a = 0
      }, 1500)
    },
  },
}
</script>
<style lang="less" scoped>
.app {
  /*width: 1920px;*/
  height: 100%;
}
</style>
